export default "__VITE_ASSET__4ZxVs0sZ__"